import useFetch from '../../api/useFetch';
import CardGrid from '../cards/layout/CardGrid';
import { useTheme, Typography, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CategoryIcon from '@mui/icons-material/Category';
import { tokens } from '../../global/theme/tokens';
import { ExoSkeleton } from '../exo/ExoSkeleton';
import ExoAvatar from '../exo/ExoAvatar';

export const SelectSalesObject = ({ onSelect, selected }) => {
  const { apiData } = useFetch('sales-objects?sortOrder=desc');

  return (
    <CardGrid className="overflow-y-auto pb-4">
      {!apiData ? (
        <ExoSkeleton n={5} size="100%" />
      ) : (
        <>
          {apiData.data.map((item) => (
            <SalesObjectGridItem
              key={item.id}
              item={item}
              onClick={onSelect}
              selected={selected?.id === item.id}
            />
          ))}
        </>
      )}
    </CardGrid>
  );
};

const SalesObjectGridItem = ({ item, onClick, selected }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  const { ownerType, owner, image, title, nr } = item;

  const nameMap = {
    companyLead: owner?.nameShort || owner?.name,
    personLead: `${owner?.salutation} ${owner?.lastName} ${owner?.firstName}`,
    company: owner?.nameShort || owner?.name,
    contact: `${owner?.salutation} ${owner?.lastName} ${owner?.firstName}`,
    internal: t('internal'),
  };

  const name = ownerType ? nameMap[ownerType] : t('internal');

  return (
    <Button
      onClick={() => onClick(item)}
      variant="contained"
      color="secondary"
      sx={{
        transition: 'scale 0.3s ease',
        padding: '5px',
        bgcolor: selected ? colors.selected : 'auto',
      }}
      className=" cursor-pointer w-full flex flex-col backdrop-blur-lg items-center rounded-lg"
    >
      {image ? (
        <img
          src={image.temporaryUrl}
          className="h-32 rounded-[5px] max-w-full object-cover"
        />
      ) : (
        <ExoAvatar
          picture={owner?.logo && owner.logo.temporaryUrl}
          type={ownerType}
          name={name}
          icon={<CategoryIcon sx={{ fontSize: '55px' }} />}
          size="128px"
        />
      )}
      <Typography variant="h5" className="pt-4">
        <b>{title}</b>
      </Typography>
      <Typography variant="h6">{name}</Typography>
      <Typography
        variant="h5"
        className="pt-1 monospace w-full"
        textAlign="right"
      >
        {nr}
      </Typography>
    </Button>
  );
};
